import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ApiService } from '@app/core/services/api/api.service';
import { SettingsService } from '@app/services/settings/settings.service';
import { ShopService } from '@app/services/shops/shop.service';
import { ToastService } from '@app/storybook/services/toast/toast.service';
import { NotificationsSettings, NotificationsSettingsToDisplayName } from '@pdqdev/pdq-shared/dist/entities';

@Component({
  selector: 'app-notifications-internal',
  templateUrl: './notifications-internal.component.html',
  styleUrls: ['./notifications-internal.component.scss', '../../settings.scss'],
  standalone: false,
})
export class NotificationsInternalComponent implements OnInit {
  defaultNotifications = [];
  isLoading;
  formGroup;
  NotificationsSettingsToDisplayName = NotificationsSettingsToDisplayName;
  initialForm;
  userMail: string;
  constructor(
    private settingsService: SettingsService,
    private shopService: ShopService,
    private toastService: ToastService,
    private readonly _apiService: ApiService,
  ) {}

  ngOnInit(): void {
    const formGroup = {};
    this.defaultNotifications = Object.keys(NotificationsSettings);
    this.settingsService.getNotificationsSettings().subscribe((data: any) => {
      Object.keys(NotificationsSettings).forEach((notification) => {
        const savedNotification = data.find((item) => item.title === notification);
        formGroup[notification] = new UntypedFormGroup({
          enabled: new UntypedFormControl(savedNotification ? savedNotification.enabled : false),
          sound: new UntypedFormControl(savedNotification ? savedNotification.sound : false),
          email: new UntypedFormControl(savedNotification ? savedNotification.email : false),
          id: new UntypedFormControl(savedNotification ? savedNotification.id : 0),
        });
      });
      this.formGroup = new UntypedFormGroup(formGroup);
      this.initialForm = this.formGroup.value;
    });
    this._apiService.get('me').subscribe((user) => {
      this.userMail = user.email;
    });
  }

  onSubmit() {
    const values = this.formGroup.value;
    const dirtyKeys = this.defaultNotifications.filter((key) => this.formGroup.controls[key].dirty);
    if (dirtyKeys) {
      this.isLoading = true;
      const data = Object.entries(this.formGroup.value)
        .filter(([key]) => dirtyKeys.includes(key))
        .map(([title, obj]: any) => ({
          title,
          ...obj,
          shop: this.shopService.shopId,
          userMail: this.userMail,
          type: 'default',
        }));
      this.settingsService.saveInternalNotifications(data).subscribe(
        (data) => {
          this.isLoading = false;
          this.initialForm = values;
          this.formGroup.markAsPristine();
        },
        (error) => {
          this.toastService.showToast({ message: error.message, mode: 'danger' });
        },
      );
    }
  }

  resetForm() {
    this.formGroup.setValue({ ...this.initialForm });
    this.formGroup.markAsPristine();
  }

  soundChanged(notification) {
    this.formGroup.controls[notification].controls.sound.setValue(!this.formGroup?.value[notification].sound);
    this.formGroup.controls[notification].markAsDirty();
  }
}
